export default __webpack_public_path__ + "static/case-img-2623104ad2362b551a384f90e30baf97.jpg";